export default __webpack_public_path__ + "static/icon-25-6-4ba36b3b8b04d5c73c97e763990c0467.png";